import React from "react";
import IconoNews from "../../../medatatheme/assets/icons/newspaper.png"

const HomeSurvey = () => {
  return (
    <div className="d-flex align-items-center justify-content-around newsletter-info-title">
      <div className="newsletter-info-title d-flex align-items-center">
        <img className="d-ib pr-3" src={IconoNews} alt="newspaper" />
        <div className="d-ib">
          <p class="newsletter-title">
            Queremos saber tu opinión...
            <br />
            <b>Ayúdanos </b> a contestar nuestra encuesta de satisfacción.
          </p>
        </div>
      </div>
      <div className="input-wrapper">
        <a className="button button-secondary" href="/form/encuesta-de-satisfaccion">
          IR A ENCUESTA
        </a>
      </div>
    </div>
  );
};

export default HomeSurvey;
